import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const Accordion = ({ items, defaultOpen = null }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpen);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={styles.accordion}>
      {items.map((item, index) => (
        <div key={index} style={styles.accordionItem}>
          <button
            onClick={() => toggleItem(index)}
            style={{
              ...styles.accordionButton,
              ...(openIndex === index ? styles.accordionButtonActive : {})
            }}
            aria-expanded={openIndex === index}
          >
            <span style={styles.accordionTitle}>{item.title}</span>
            <span style={styles.accordionIcon}>
              {openIndex === index ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
            </span>
          </button>
          
          <div
            style={{
              ...styles.accordionContent,
              ...(openIndex === index ? styles.accordionContentOpen : {})
            }}
          >
            <div style={styles.accordionInner}>
              {item.content}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const styles = {
  accordion: {
    width: '100%',
  },
  
  accordionItem: {
    marginBottom: '12px',
    border: '2px solid #2C2C2C',
    borderRadius: '8px',
    overflow: 'hidden',
    background: '#1A1F3A',
  },
  
  accordionButton: {
    width: '100%',
    padding: '16px 20px',
    background: 'transparent',
    border: 'none',
    color: '#FFFFFF',
    fontSize: '18px',
    fontWeight: '700',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    textAlign: 'left',
    minHeight: '56px', // Touch-friendly
    transition: 'background 0.3s ease',
  },
  
  accordionButtonActive: {
    background: 'rgba(227, 30, 36, 0.1)',
  },
  
  accordionTitle: {
    flex: 1,
    paddingRight: '12px',
  },
  
  accordionIcon: {
    color: '#E31E24',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  
  accordionContent: {
    maxHeight: '0',
    overflow: 'hidden',
    transition: 'max-height 0.3s ease',
  },
  
  accordionContentOpen: {
    maxHeight: '2000px', // Large enough for most content
  },
  
  accordionInner: {
    padding: '20px',
    color: '#FFFFFF',
    fontSize: '16px',
    lineHeight: '1.6',
    borderTop: '1px solid rgba(255,255,255,0.1)',
  },
};

export default Accordion;
